import React from 'react';
import './UIButtonToolbar.css';

interface UIButtonToolbarButtonProps {
  id: number;
  name: string;
  active: boolean;
  count?: number;
}

interface UIButtonToolbarProps {
  uiButtons: UIButtonToolbarButtonProps[];
  buttonClicked: (id: number) => void;
}

function UIButtonToolbar(props: UIButtonToolbarProps) {
  const { uiButtons, buttonClicked } = { ...props };

  return (
    <div id='ui-button-toolbar' className='ui-button-toolbar'>
      {uiButtons.map((uiButton: UIButtonToolbarButtonProps) => {
        const { id, name, active, count } = { ...uiButton };

        return (
          <button
            key={id}
            id={name}
            data-testid={`${name}-button`}
            className={
              active
                ? 'ui-button-toolbar-button ui-button-toolbar-button-active semi-bold'
                : 'ui-button-toolbar-button semi-bold'
            }
            onClick={() => buttonClicked(id)}
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <span>{name}</span>
            {count !== undefined && (
              <span
                className='inline-flex items-center justify-center text-white font-semibold'
                style={{
                  backgroundColor: '#001023', // Dark blue/navy background
                  borderRadius: '2px', // Rectangular shape with slight rounding
                  minWidth: '24px',
                  height: '20px',
                  fontSize: '12px',
                  paddingLeft: '6px',
                  paddingRight: '6px',
                }}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default UIButtonToolbar;
